module.exports = __webpack_public_path__ + "img/03-hero-3d-app-icon.b6efa5bf.webp";